import React, { createContext, useEffect, useReducer, useRef } from "react";

export const USER_ACTION_TYPES = {
    GET_PROFILE: "GET_PROFILE",
    CLEAR_PROFILE: "CLEAR_PROFILE",
    GET_RATING: "GET_RATING",
    CLEAR_RATING: "CLEAR_RATING",
};

const initialState = {
    profile: null,
    rating: null,
};

const UserContext = createContext({
    state: initialState,
    dispatch: () => { },
    getState: () => initialState,
    types: USER_ACTION_TYPES,
});

let globalUserStoreBridge = {
    getState: () => initialState,
    dispatch: () => { },
    types: USER_ACTION_TYPES,
};

function userReducer(state, action) {
    switch (action.type) {
        case USER_ACTION_TYPES.GET_PROFILE:
            return {
                ...state,
                profile: action.payload,
            };
        case USER_ACTION_TYPES.CLEAR_PROFILE:
            return {
                ...state,
                profile: null,
            };
        case USER_ACTION_TYPES.GET_RATING:
            return {
                ...state,
                rating: action.payload,
            };
        case USER_ACTION_TYPES.CLEAR_RATING:
            return {
                ...state,
                rating: null,
            };
        default:
            return state;
    }
}

export function UserProvider({ children }) {
    const [state, dispatch] = useReducer(userReducer, initialState);
    const stateRef = useRef(state);

    useEffect(() => {
        stateRef.current = state;
    }, [state]);

    const value = {
        state,
        dispatch,
        getState: () => stateRef.current,
        types: USER_ACTION_TYPES,
    };

    useEffect(() => {
        globalUserStoreBridge = {
            getState: () => stateRef.current,
            dispatch,
            types: USER_ACTION_TYPES,
        };
    }, [dispatch]);

    return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}

export function getUserStoreBridge() {
    return globalUserStoreBridge;
}
